import { render } from "./Reset_password.vue?vue&type=template&id=ca0c7942&scoped=true"
import script from "./Reset_password.vue?vue&type=script&lang=js"
export * from "./Reset_password.vue?vue&type=script&lang=js"

import "./Reset_password.vue?vue&type=style&index=0&id=ca0c7942&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0c7942"]])

export default __exports__